import React from 'react';
import { Pressable, View } from 'react-native';
import { Text } from '@/components/ui/text';

interface SectionHeaderProps {
  title: string;
  actionText?: string;
  onActionPress?: () => void;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  actionText = "See All",
  onActionPress
}) => {
  return (
    <View className="flex-row justify-between items-center mb-4">
      <Text className="font-bold text-lg text-foreground" accessibilityRole="header">
        {title}
      </Text>
      {onActionPress && actionText && (
        <Pressable
          onPress={onActionPress}
          accessibilityRole="button"
          accessibilityLabel={`${actionText} ${title}`}
          hitSlop={{ top: 12, bottom: 12, left: 12, right: 12 }}
        >
          <Text className="font-medium text-sm text-muted-foreground">
            {actionText}
          </Text>
        </Pressable>
      )}
    </View>
  );
};

export default SectionHeader;
